module.exports = __webpack_public_path__ + "static/img/arduinoUnoDIP-1.1286f4d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/arduinoUnoDIP-1.svg
// module id = opdd
// module chunks = 0